import { lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import BackToTop from "./components/BackToTop";
import ContactChatPopup from "./components/ContactChatPopup";
import { SmoothScroll } from "./components/SmoothScroll";
import { ContactChatProvider } from "./context/ContactChatContext";
import { HomeSplashScrollProvider } from "./context/HomeSplashScrollContext";
import PageLoadingScreen from "./components/PageLoadingScreen";
import GlobalScrollbar from "./components/GlobalScrollbar";

// Route-level code splitting — mỗi page là 1 chunk riêng
const HomePage         = lazy(() => import("./pages/HomePage"));
const AboutPage        = lazy(() => import("./pages/AboutPage"));
const PortfolioPage    = lazy(() => import("./pages/PortfolioPage"));
const Portfolio2026    = lazy(() => import("./pages/Portfolio2026"));
const CareersPage      = lazy(() => import("./pages/CareersPage"));
const JobDetailPage    = lazy(() => import("./pages/JobDetailPage"));
const ContactPage      = lazy(() => import("./pages/ContactPage"));
const GameDetailPage   = lazy(() => import("./pages/GameDetailPage"));
const TermsPage        = lazy(() => import("./pages/TermsPage"));
const PrivacyPolicyPage = lazy(() => import("./pages/PrivacyPolicyPage"));
const BlogDetailPage   = lazy(() => import("./pages/BlogDetailPage"));

export default function App() {
  return (
    <Router>
      <ContactChatProvider>
        <HomeSplashScrollProvider>
          <SmoothScroll>
            <PageLoadingScreen />
            <Suspense fallback={null}>
              <Routes>
                <Route path="/"                    element={<HomePage />} />
                <Route path="/about"               element={<AboutPage />} />
                <Route path="/portfolio"           element={<PortfolioPage />} />
                <Route path="/portfolio-2026/:project?" element={<Portfolio2026 />} />
                <Route path="/careers"             element={<CareersPage />} />
                <Route path="/careers/:slug"       element={<JobDetailPage />} />
                <Route path="/contact-us"          element={<ContactPage />} />
                <Route path="/terms-and-conditions" element={<TermsPage />} />
                <Route path="/privacy-policy"      element={<PrivacyPolicyPage />} />
                <Route path="/games/:slug"         element={<GameDetailPage />} />
                <Route path="/blog/:slug"          element={<BlogDetailPage />} />
              </Routes>
            </Suspense>
            <BackToTop />
            <ContactChatPopup />
            <GlobalScrollbar />
          </SmoothScroll>
        </HomeSplashScrollProvider>
      </ContactChatProvider>
    </Router>
  );
}
